/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentFeeMode } from './TournamentFeeMode';
import {
    TournamentFeeModeFromJSON,
    TournamentFeeModeFromJSONTyped,
    TournamentFeeModeToJSON,
    TournamentFeeModeToJSONTyped,
} from './TournamentFeeMode';

/**
 * 
 * @export
 * @interface RegisterTeamBody
 */
export interface RegisterTeamBody {
    /**
     * Team name (3-30 characters)
     * @type {string}
     * @memberof RegisterTeamBody
     */
    name: string;
    /**
     * The captain's own in-game name (2-32 characters) — snapshot to their roster entry for score verification
     * @type {string}
     * @memberof RegisterTeamBody
     */
    playerName: string;
    /**
     * Team tag (2-6 characters, optional)
     * @type {string}
     * @memberof RegisterTeamBody
     */
    tag?: string;
    /**
     * 
     * @type {TournamentFeeMode}
     * @memberof RegisterTeamBody
     */
    feeMode?: TournamentFeeMode;
    /**
     * Tournament password (required for private tournaments)
     * @type {string}
     * @memberof RegisterTeamBody
     */
    password?: string;
    /**
     * User IDs to invite to the team after creation
     * @type {Array<string>}
     * @memberof RegisterTeamBody
     */
    invitedUserIds?: Array<string>;
    /**
     * Email addresses to invite to the team after creation
     * @type {Array<string>}
     * @memberof RegisterTeamBody
     */
    invitedEmails?: Array<string>;
    /**
     * Optional universal Team ID to seed roster from. Caller must be captain of that team.
     * @type {string}
     * @memberof RegisterTeamBody
     */
    sourceTeamId?: string;
}



/**
 * Check if a given object implements the RegisterTeamBody interface.
 */
export function instanceOfRegisterTeamBody(value: object): value is RegisterTeamBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('playerName' in value) || value['playerName'] === undefined) return false;
    return true;
}

export function RegisterTeamBodyFromJSON(json: any): RegisterTeamBody {
    return RegisterTeamBodyFromJSONTyped(json, false);
}

export function RegisterTeamBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterTeamBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'playerName': json['playerName'],
        'tag': json['tag'] == null ? undefined : json['tag'],
        'feeMode': json['feeMode'] == null ? undefined : TournamentFeeModeFromJSON(json['feeMode']),
        'password': json['password'] == null ? undefined : json['password'],
        'invitedUserIds': json['invitedUserIds'] == null ? undefined : json['invitedUserIds'],
        'invitedEmails': json['invitedEmails'] == null ? undefined : json['invitedEmails'],
        'sourceTeamId': json['sourceTeamId'] == null ? undefined : json['sourceTeamId'],
    };
}

export function RegisterTeamBodyToJSON(json: any): RegisterTeamBody {
    return RegisterTeamBodyToJSONTyped(json, false);
}

export function RegisterTeamBodyToJSONTyped(value?: RegisterTeamBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'playerName': value['playerName'],
        'tag': value['tag'],
        'feeMode': TournamentFeeModeToJSON(value['feeMode']),
        'password': value['password'],
        'invitedUserIds': value['invitedUserIds'],
        'invitedEmails': value['invitedEmails'],
        'sourceTeamId': value['sourceTeamId'],
    };
}

